import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import { MediaFileInput } from '~admin/view/components/ui/form/fields/media-file/media-file-input.component';
import { MediaType } from '~client/model/media-type';

interface Props {
  name?: string;
  label?: string;
  mediaType: MediaType;
  onMediaSelected?: (width: number, height: number) => void;
}

export const MediaFileField: React.FunctionComponent<Props> = ({
  name,
  label,
  mediaType,
  onMediaSelected,
  ...rest
}) => (
  <Field
    name={name}
    render={(renderProps): ReactNode => (
      <MediaFileInput
        label={label}
        mediaType={mediaType}
        onMediaSelected={onMediaSelected}
        {...renderProps}
      />
    )}
    {...rest}
  />
);



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-media-file.component.tsx